import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import {
  GET_CURRENT_ACADID,
  GET_STUDENT_LIST_START,
  GET_SUBJECT_START_COMMON,
  GET_DIVISION_START,
  UPLOAD_IMAGE_REQUEST,
  UPLOAD_IMAGE_FAILURE,
  UPLOAD_IMAGE_SUCCESS
} from "./Constants"
import {
  getCurrentAcadIdAPI,
  divisionAPI,
  subjectAPI,
  StudentListApi,
} from "./Api"
import { toast } from "react-toastify"
import {
  getCurrentAcadidFailed,
  getCurrentAcadidSuccess,
  getDivisionSuccess,
  getDivisionFail,
  getSubjectSuccessCommon,
  getSubjectFailCommon,
  getStudentSuccess,
  getStudentFail,
} from "./Actions"
import axios from "axios"

function* getCurrentAcadId(action) {
  try {
    const response = yield call(getCurrentAcadIdAPI, action.payload)
    if (response) {
      yield put(
        getCurrentAcadidSuccess(
          Array.isArray(response.data) ? response.data[0] : []
        )
      )
    } else {
      throw response
    }
  } catch (error) {
    console.log("error", error)
    yield put(
      getCurrentAcadidFailed(
        error.response.data || "Unable to get Bottom Nav Icons Icons"
      )
    )
  }
}

function* getDivision(action) {
  try {
    const response = yield call(divisionAPI, action.payload)
    if (response) {
      yield put(getDivisionSuccess(response.data.data))
    } else {
      throw response
    }
  } catch (error) {
    console.log("error", error)
    yield put(getDivisionFail(error.response.data || "something went wrong"))
  }
}

function* getSubjectApiAsync(action) {
  try {
    const response = yield call(subjectAPI, action.payload)
    if (response) {
        console.log(response.data.data)
      yield put(getSubjectSuccessCommon(response.data.data))
    } else {
      throw response
    }
  } catch (error) {
    console.log("error", error)
    yield put(getSubjectFailCommon(error.response.data || "something went wrong"))
  }
}

function* getStudentList(action) {
  // console.log(action.payload)
  try {
    const response = yield call(StudentListApi, action.payload)
    // console.log(response)
    if (response.status == 200) {
      yield put(getStudentSuccess(response.data.data))
    } else {
      throw response
    }
  } catch (error) {
    console.log("error", error)
    yield put(getStudentFail(error.response.data || "something went wrong"))
  }
}

function* uploadImageSaga(action) {
  const token = JSON.parse(localStorage.getItem("Token"))
  const { Uid, croppedImageUrl, navigate } = action.payload;

  if (!croppedImageUrl) {
    toast.error("file is missing");
    return;
  }

  try {
    const blob = yield call(async () => {
      const response = await fetch(croppedImageUrl);
      return response.blob();
    });

    const file = new File([blob], "cropped-image.jpg", { type: "image/jpeg" });

    const formData = new FormData();
    formData.append("student_id", Uid);
    formData.append("files", file);

    const response = yield call(() =>
      axios.post("https://marcopolo.prisms.in/api/StudentProfilePic/upload-picture", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      })
    );

    if (response.status === 200) {
      toast.success("Image uploaded successfully!");
      yield put({ type: UPLOAD_IMAGE_SUCCESS });
      navigate(-1);
    } else {
      toast.error("Unexpected error during upload.");
      yield put({ type: UPLOAD_IMAGE_FAILURE });
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response?.data?.message || "An error occurred.");
    yield put({ type: UPLOAD_IMAGE_FAILURE });
  }
}

function* CommonSaga() {
  yield takeEvery(GET_CURRENT_ACADID, getCurrentAcadId)
  yield takeLatest(GET_DIVISION_START, getDivision)
  yield takeLatest(GET_SUBJECT_START_COMMON, getSubjectApiAsync)
  yield takeLatest(GET_STUDENT_LIST_START, getStudentList)
  yield takeLatest(UPLOAD_IMAGE_REQUEST, uploadImageSaga);

  //yield takeLatest(LOGOUT_SU_USER, logoutUser)
}

export default CommonSaga
